<template>
  <h2>Mods for {{ playerName }} ({{ allyCode }})</h2>
  <section class="mod-list">
    <Mod
      v-for="(mod, i) in mods"
      :key="mod.id"
      :mod="mod"
      :index="i"
      @intersected="$emit('intersected', $event)"
      @click.stop="$emit('selected', mod)"
    />
  </section>
</template>

<script>
import Mod from "./Mod.vue";

export default {
  props: {
    mods: {
      type: Array,
      default: [],
    },
    playerName: {
      type: String,
      default: "",
    },
    allyCode: {
      type: String,
      default: "",
    },
  },
  emits: ["selected", "intersected"],
  components: { Mod },
};
</script>
